<template>
  <div id="transmision_manifestacion">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card color="primary" icon="library_books" title="Manifestación Electrónica"
            class="elevation-1 px-5 py-3">
            <v-card-actions>
              <v-spacer></v-spacer>




              <v-btn fab dark x-small color="green darken-2" @click.native="modal = true; cargarSolicitudes(0)"
                title="Crear Nueva Solicitud" v-tippy>
                <v-icon dark>add</v-icon>
              </v-btn>
              <v-btn fab dark x-small color="secondary" to='/mv_cargamv' title="Crear Nueva Solicitud - Layout" v-tippy>
                <v-icon>mdi-upload</v-icon>
              </v-btn>
               <v-btn fab dark x-small color="cyan darken-2" title="Descargar Layout"
                @click="downloadLayoutAyuda('layout_manifestacion.xlsx')" v-tippy>
                <v-icon dark>mdi-table</v-icon>
              </v-btn>
              <v-btn fab dark x-small color="blue darken-2" title="Información de Ayuda"
                @click="downloadLayoutAyuda('Plantillas/Catalogo_MV.xlsx')" v-tippy>
                <v-icon dark>info</v-icon>
              </v-btn>
            </v-card-actions>



            <v-card-text>
              <v-form ref="formreporte" lazy-validation>
                <v-container grid-list-md text-xs-center>

                  <v-row row wrap>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary"
                            prepend-icon="event" @blur="
                              fecha_de = parseDate(fecha_de)
                              " v-mask="'####-##-##'" :rules="[
                                rules.required,
                                validaDias,
                                validaFecha,
                                $rules.validaDiasConsulta(fecha_de, fecha_a)
                              ]">
                          </v-text-field>
                        </template>

                        <v-date-picker v-model="fecha_de" color="secondary" landscape scrollable locale="es-mx"
                          @input="menu1 = false">
                          <v-spacer />

                          <v-btn color="secondary" large @click="menu1 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary"
                            prepend-icon="event" @blur="fecha_a = parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[
                              rules.required,
                              validaDias,
                              validaFecha,
                              $rules.validaDiasConsulta(fecha_de, fecha_a)
                            ]"></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha_a" color="secondary" landscape scrollable locale="es-mx"
                          @input="menu2 = false">
                          <v-spacer />

                          <v-btn color="secondary" large @click="menu2 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="12" md="2" lg="2">
                      <v-switch v-model="fecha_factura" color="red darken-3" label="Fecha de Pedimento"></v-switch>
                    </v-col>
                    <v-col sm="12" md="2" lg="2">
                      <v-btn rounded color="secondary" @click="cargar()">
                        <v-icon>search</v-icon>Consultar
                      </v-btn>
                    </v-col>
                  </v-row>

                </v-container>
              </v-form>

              <div id="datagrid">
                 <v-refresh-button :funcion="cargar" />
                <v-client-table ref="principalTable" :data="registros.items" :columns="columns" :options="options"
                  class="elevation-2 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                  </template>
                  <template slot="error" slot-scope="props">
                    <div class="columnaError">
                      {{ props.row.error }}
                    </div>
                  </template>
                  <template slot="estatus" slot-scope="props">
                    <div v-if='props.row.estatus != "Transmitido con errores" && props.row.estatus != "Rechazada"' class="text-center">
                      {{ props.row.estatus.toUpperCase() }}
                    </div>
                    <div :title="props.row.error" v-if="props.row.estatus == 'Transmitido con errores' ||  props.row.estatus == 'Rechazada'"
                      style="color:red">

                      <v-dialog v-model="dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn text color="error"  v-bind="attrs" v-on="on" :title="props.row.error">
                           <u> {{ props.row.estatus.toUpperCase() }}</u>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="text-h5 red lighten-2">
                            {{props.row.estatus}}
                          </v-card-title>

                          <v-card-text>
                            {{ props.row.error }}
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog = false">
                              Cerrar
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </template>
                  <template slot="actions" slot-scope="props">

                    <v-row>
                      <v-col sm="12" md="2" lg="2"
                        v-if="(props.row.estatus != 'Transmitido correctamente' && props.row.estatus != 'Transmitido y Consultado' && props.row.estatus != 'Transmitiendo')">
                        <v-speed-dial direction="left" open-on-hover>
                          <template v-slot:activator>
                            <v-btn x-small fab dark color="primary" title="Acciones" v-tippy>
                              <v-icon v-if="fab">mdi-close</v-icon>
                              <v-icon v-else>reorder</v-icon>
                            </v-btn>
                          </template>

                          <v-btn x-small fab dark color="cyan darken-2"
                            v-if="false && (props.row.estatus != 'Transmitido correctamente' && props.row.estatus != 'Transmitido y Consultado' && props.row.estatus != 'Transmitiendo')"
                            @click.native="uploadLayoutMV(props.row.id, props.row.nombre_proceso)"
                            title="Cargar Complementarios" v-tippy>
                            <v-icon>mdi-arrow-up-bold-circle</v-icon>
                          </v-btn>

                          <!--JEMM (04-ago-2021): LOURDES señala que en eManifiesto no se debe mandar recuperar el pedimento ni traerse edocs y coves del pedimento, solo los que se agreguen en la vista -->
                          <!--v-btn x-small fab dark color="blue darken-2" v-if="(props.row.estatus != 'Transmitido correctamente' && props.row.estatus != 'Transmitido y Consultado' && props.row.estatus != 'Transmitiendo')"
                                             @click.native="consulta_pedimento(props.row.id);" title="Confrontar con pedimento" v-tippy>
                                            <span class="material-icons">compare_arrows</span>
                                        </v-btn-->
                          <v-btn x-small fab dark color="orange"
                            v-if="(props.row.estatus != 'Transmitido correctamente' && props.row.estatus != 'Transmitido y Consultado' && props.row.estatus != 'Transmitiendo')"
                            @click.native="openModal(props.row)" title="Completar Registro" v-tippy>
                            <v-icon>edit</v-icon>
                          </v-btn>

                          <v-btn x-small fab dark color="blue"
                            v-if="( (props.row.estatus == 'Sin transmitir' || props.row.estatus == 'Transmitido con errores' || props.row.estatus == 'Pagos no cargados'  || props.row.estatus == 'Rechazada'))"
                            @click.native="transmitir(props.row.id, props.row.estatus)" title="Transmitir" v-tippy>
                            <v-icon>send</v-icon>
                          </v-btn>
                           <v-btn x-small fab dark color="blue" v-if="props.row.estatus == 'Pendiente de aceptación'"
                            @click.native="consultar_operacion(props.row.id)" title="Consultar Aceptación" v-tippy>
                            <v-icon>mdi-reload</v-icon>
                          </v-btn>
                          <!--v-btn x-small fab dark color="blue"
                            v-if="(props.row.datosManifestacionValor == 1 && (props.row.estatus == 'Sin transmitir' || props.row.estatus == 'Transmitido con errores'))"
                            @click.native="SimularTransmision(props.row.id)" title="Simular Transmisión" v-tippy>
                            <v-icon>mdi-chemical-weapon</v-icon>
                          </v-btn-->
                          <v-btn x-small fab dark color="pink"
                            v-if="(props.row.estatus == 'Sin transmitir' || props.row.estatus == 'Pagos no cargados' || props.row.estatus == 'Completar registro' || props.row.estatus == 'Transmitido con errores' || props.row.estatus == 'Rechazada')"
                            @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                            <v-icon>delete</v-icon>
                          </v-btn>

                        </v-speed-dial>
                      </v-col>
                      <v-col sm="12" md="2" lg="2"
                        v-if="props.row.estatus == 'Transmitido y Consultado' || props.row.estatus == 'Transmitido con errores' || props.row.estatus == 'Rechazada'">

                        <v-speed-dial direction="left" open-on-hover>
                          <template v-slot:activator>
                            <v-btn x-small fab dark color="secondary" title="Descarga Comprobantes" v-tippy>
                              <v-icon v-if="fab">mdi-close</v-icon>
                              <v-icon v-else>mdi-file-multiple</v-icon>
                            </v-btn>
                          </template>
                          <v-btn x-small fab dark color="red"
                            v-if="props.row.estatus == 'Transmitido y Consultado'"
                            @click.native="downloadFile(props.row.rfc + '/manifestacion/' + props.row.id + '/' + props.row.json_consulta_response.eDocument + '.pdf')"
                            title="PDF Manifestación" v-tippy>
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>

                          <v-btn x-small fab dark color="orange"
                            v-if="props.row.estatus == 'Transmitido y Consultado'"
                            @click.native="downloadFile(props.row.rfc + '/manifestacion/' + props.row.id + '/Acuse_' + props.row.json_consulta_response.eDocument + '.pdf')"
                            title="PDF Acuse Manifestación" v-tippy>
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          <v-btn x-small fab dark color="blue" v-if="props.row.datosComplementarios == 1 && false"
                            @click.native="downloadFormatoE2(props.row)" title="Formato E2" v-tippy>
                            <v-icon>mdi-file-document-outline</v-icon>
                          </v-btn>
                          <v-btn x-small fab dark color="grey"
                            v-if="props.row.estatus == 'Transmitido y Consultado' || props.row.estatus == 'Transmitido con errores' || props.row.estatus == 'Rechazada'"
                            @click.native="generaZipEvidencia(props.row.id)" title="Zip Evidencias" v-tippy>
                            <v-icon>mdi-folder-zip-outline</v-icon>
                          </v-btn>
                            <v-btn x-small fab dark color="cyan"
                            v-if="props.row.estatus == 'Transmitido y Consultado' "
                            @click.native="regenerapdfs(props.row.id)" title="Regenerar Documentos PDF" v-tippy>
                            <v-icon>mdi-cog</v-icon>
                          </v-btn>
                          <v-btn x-small fab dark color="red" v-if="props.row.estatus == 'Transmitido y Consultado'"
                            @click.native="cancelRegistro(props.row.id)" title="Cancelar Manifestación" v-tippy>
                            <v-icon>mdi-cancel</v-icon>
                           </v-btn>

                        </v-speed-dial>
                      </v-col>
                      <v-col sm="12" md="8" lg="8">
                        <v-btn x-small fab dark color="green" @click.native="getRecuperaciones(props.row);"
                          title="Recuperaciones" v-tippy>
                          <v-icon>mdi-table-clock</v-icon>
                        </v-btn>
                        <v-btn x-small fab dark color="primary"
                          @click.native="vistaPrevia(props.row.id, props.row.nombre_proceso)"
                          title="Consultar Manifestación" v-tippy>
                          <v-icon>mdi mdi-window-restore</v-icon>
                        </v-btn>
                        <v-btn x-small fab dark color="red" v-if="props.row.datosComplementarios == 1 && props.row.estatus != 'Transmitido y Consultado'"
                          @click.native="downloadVistaPrevia(props.row)" title="Vista Previa Manifestación" v-tippy>
                          <v-icon>mdi-file-pdf-box</v-icon>
                        </v-btn>



                      </v-col>
                    </v-row>
                  </template>
                </v-client-table>
              </div>

            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>


    <!-- MODAL PARA CARGAR LISTA DE EDOCS 2-->
    <v-dialog v-model="dialog3" max-width="500px">
      <v-card>
        <v-card-text>
          <h5>Ingrese lista de eDocuments</h5>
          <span>Uno por línea</span><br>
          <v-form ref="formListado" lazy-validation="">
            <v-textarea outlined rows="12" v-model="model_nuevo.lista_edocuments"
              :rules="[rules.required]"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="danger" @click="dialog3 = false;">Cancelar</v-btn>
          <v-btn small color="primary" @click="setListValuesNuevo(); dialog3 = false;">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- MODAL PARA CARGAR LISTA DE COVES 2-->
    <v-dialog v-model="dialog4" max-width="500px">
      <v-card>
        <v-card-text>
          <h5>Ingrese lista de Coves</h5>
          <span>Uno por línea</span><br>
          <v-form ref="formListadoCoves" lazy-validation="">
            <v-textarea outlined rows="12" v-model="model_nuevo.lista_coves" :rules="[rules.required]"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn small color="danger" @click="dialog4 = false;">Cancelar</v-btn>
          <v-btn small color="primary" @click="setListValuesCovesNuevo(); dialog4 = false;">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA CARGAR LISTA DE EDOCS 1-->
    <v-dialog v-model="dialog1" max-width="500px">
      <v-card>
        <v-card-text>
          <h5>Ingrese lista de eDocuments</h5>
          <span>Uno por línea</span><br>
          <v-form ref="formListado" lazy-validation="">
            <v-textarea outlined rows="15" v-model="model.lista_edocuments" :rules="[rules.required]"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="danger" @click="dialog1 = false;">Cancelar</v-btn>
          <v-btn small color="primary" @click="setListValues(); dialog1 = false;">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <!-- MODAL PARA CARGAR LISTA PROCESOS-->
    <v-dialog v-model="dialog_edocs" max-width="500px">
      <v-card>
        <v-card-text>
          <h5>Ingrese Números de Proceso</h5>
          <span>Uno por línea</span><br>
          <v-form ref="formListado" lazy-validation="">
            <v-textarea outlined rows="15" v-model="model.lista_procesos" :rules="[rules.required]"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="danger" @click="dialog_edocs = false;">Cancelar</v-btn>
          <v-btn small color="primary" @click="setListValuesProcesos(); dialog_edocs = false;">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- MODAL PARA CARGAR LISTA DE COVES 1-->
    <v-dialog v-model="dialog2" max-width="500px">
      <v-card>
        <v-card-text>
          <h5>Ingrese lista de Coves</h5>
          <span>Uno por línea</span><br>
          <v-form ref="formListadoCoves" lazy-validation="">
            <v-textarea outlined rows="15" v-model="model.lista_coves" :rules="[rules.required]"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
         <v-btn small color="danger" @click="dialog2 = false;">Cancelar</v-btn>
          <v-btn small color="primary" @click="setListValuesCoves(); dialog2 = false;">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA VISTA PREVIA-->
    <v-dialog v-model="dialogVP" max-width="95%">
      <v-card>

        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="dialogVP = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Consultar Manifestación</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-vista-previa :key="keyVistaPrevia" />

        </v-card-text>
      </v-card>


    </v-dialog>

    <!-- MODAL PARA RECUPERACIONES-->
    <v-dialog v-model="dialogRecuperaciones" max-width="1000px">
      <v-card>

        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="dialogRecuperaciones = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Recuperaciones para la Manifestación</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <strong>{{ manifestacion_actual }}</strong>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="dataRecuperaciones.length > 0" small color="secondary"
              title="Actualiza el Estatus de Recuperación" @click.native="actualizarRecuperaciones()"
              v-tippy><v-icon>refresh</v-icon>Actualizar</v-btn>
            <!--v-btn v-if="lista_coves_recuperacion.length > 0 || lista_edocs_recuperacion.length > 0" small
              color="success" title="Programa Nuevamente los Archivos No Recuperados"
              @click.native="reenviarRecuperaciones()" v-tippy><v-icon>mdi-update</v-icon>Reenviar</v-btn-->
          </v-card-actions>
          <v-client-table ref="tableRecuperaciones" :data="dataRecuperaciones" :columns="columnsRecuperaciones"
            :options="optionsRecuperaciones" class="elevation-2 pa-2">
            <template slot="noResults">
              <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
            </template>
          </v-client-table>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA CARGAR LAYOUT COMPLETO COMPLEMENTARIOS-->
    <v-dialog v-model="modalPlantilla" max-width="47%" style=" z-index: 400 !important;">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="modalPlantilla = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Cargar Layout de Manifestación</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md text-xs-center>
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-container grid-list-md text-xs-center>
                  <v-row row wrap>
                    <v-col>
                      <span class="v-label theme--light font-weight-bold center">Cargar Datos Complementarios</span>
                      <br /><span class="v-label font-weight-bold center">Proceso: {{ manifestacionSeleccionada }} -
                        {{ nombre_proceso }}</span>
                    </v-col>
                  </v-row>
                  <v-row wrap justify="center">

                    <v-col sm="12" md="4" lg="4">
                      <v-row row wrap>
                        <v-col>
                          <v-btn x-small fab dark color="purple"
                            @click.native="downloadLayoutMV(manifestacionSeleccionada)"
                            title="Descargar Plantilla del Layout" v-tippy>
                            <v-icon>mdi-file-excel</v-icon> </v-btn>
                        </v-col>
                        <v-col>
                          <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" :headerRow=5
                            :firstRow=6 :headersExcel="headersExcel" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                </v-container>
              </v-card-text>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA NUEVA MANIFESTACIÓN sin necesitar archivoM -->
    <v-dialog v-model="modal" max-width="50%" style=" z-index: 400 !important;">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Nueva Manifestación</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text >
          <v-container grid-list-md text-xs-center style="margin-top: -40px;">
            <v-form ref="formnueva" lazy-validation>
              <v-card-text>
                <v-container grid-list-md text-xs-center>
                  <v-row v-if="rfc_agencia!=''">
                    <v-col sm="12" md="10" lg="10">
                      <v-autocomplete :hide-no-data="true" :items="clientes_agencia"
                        v-model="model_nuevo.rfc" :rules="[rules.required]" :item-text="getNombreCliente"
                        @change="set_rfc_cliente();" item-value="rfc"
                        label="Seleccione RFC de Cliente"></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="12" md="8" lg="8">
                      <v-text-field v-model="model_nuevo.no_pedimento" label="Número Pedimento" maxlength="16"
                        :rules="[rules.required, validaPedimento, validaPatentePermitida]"></v-text-field>
                    </v-col>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false"
                        transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model_nuevo.fecha_pedimento" label="Fecha Pedimento"
                            color="secondary" prepend-icon="event"
                            @blur="model_nuevo.fecha_pedimento = parseDate(model_nuevo.fecha_pedimento)"
                            v-mask="'####-##-##'" :rules="[rules.required, validaFecha]"></v-text-field>
                        </template>

                        <v-date-picker v-model="model_nuevo.fecha_pedimento" color="secondary" scrollable locale="es-mx"
                          @input="menu3 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu3 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="tiposManifestacion"
                        v-model="model_nuevo.tipo_manifestacion" :rules="[rules.required]" item-text="nombre"
                      item-value="clave"
                        label="Seleccione Tipo de Manifestación de Valor"></v-autocomplete>
                    </v-col>

                    <v-col sm="12" md="4" lg="4">
                      <v-text-field v-model="model_nuevo.tipo_cambio" label="Tipo de Cambio" maxlength="16"
                        :rules="[rules.required, validaFloat]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="model_nuevo.momento_transmision == 'despues'">
                    <v-col sm="12" md="6" lg="6">
                    </v-col>
                    <v-col sm="12" md="6" lg="6">
                      <v-text-field label="Ejercicio fiscal del que se trata." type="text"
                        v-model="model_nuevo.ejercicio_fiscal" maxlength="4"
                        :rules="model_nuevo.momento_transmision == 'despues' ? [rules.required, validaEntero] : []"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="rfc_agencia==''">
                    <v-col sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="rfcs_consulta" v-model="model_nuevo.rfc_consulta"
                        :rules="[rules.required]" :item-text="getNombreRfcConsulta" item-value="rfc" multiple
                        label="Seleccione RFCs de Consulta"></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="representantes"
                        v-model="model_nuevo.rfc_representante" :rules="[rules.required]"
                        :item-text="getNombreRepresentante" item-value="rfc"
                        label="Seleccione Representante Legal"></v-autocomplete>
                    </v-col>
                  </v-row>
                <!--   <v-row>
                    <v-col>
                      <v-autocomplete :hide-no-data="true" :items="representantes"
                        v-model="model_nuevo.terceros_autorizados" :rules="[rules.required, validaTercerosNuevo]"
                        :item-text="getNombreRepresentante" item-value="rfc"
                        label="Seleccione Personas Autorizadas para transmitir la manifestación"
                        multiple></v-autocomplete>
                    </v-col>
                  </v-row> -->
                  <v-row>
                  <v-col v-if="solicitudes.length>0" sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="solicitudes" v-model="model_nuevo.lista_solicitudes"
                        item-text="descripcion" multiple @change="set_coves_modelo_nuevo" item-value="descripcion"
                        label="Agregar lista preguardada COVES/EDOCS"></v-autocomplete>
                    </v-col>
                    </v-row>
                  <v-row row wrap>
                    <v-col sm="12" md="2" lg="2" >
                      <v-btn icon title="COVES Listado" v-tippy @click="dialog4 = !dialog4">
                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      Total de coves en la lista: <strong>{{ lista_filtrada_coves_nuevo.length }}</strong>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="lista_filtrada_coves_nuevo.length > 0">
                    <v-col sm="12" md="10" lg="10" @click="dialog4 = !dialog4">
                      <v-combobox v-model="lista_filtrada_coves_nuevo" label="Lista de coves" multiple persistent-hint
                        small-chips disabled color="green">
                      </v-combobox>
                    </v-col>
                  </v-row>


                    <v-row row wrap>
                    <v-col sm="12" md="2" lg="2" >
                      <v-btn icon title="eDocuments Listado" v-tippy @click="dialog3 = !dialog3">
                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      Total de eDocuments en la lista: <strong>{{ lista_filtrada_nuevo.length }}</strong>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="lista_filtrada_nuevo.length > 0">
                    <v-col sm="12" md="10" lg="10" @click="dialog3 = !dialog3">
                      <v-combobox v-model="lista_filtrada_nuevo" label="Lista de eDocuments" multiple persistent-hint
                        small-chips disabled color="green">
                      </v-combobox>
                    </v-col>
                  </v-row>



                   <v-row row wrap @click="dialog_edocs = !dialog_edocs">
                    <v-col sm="12" md="2" lg="2" >
                      <v-btn icon title="Proceso eDocuments Transmitidos" v-tippy >
                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      Agregar número de proceso de Edocuments transmitidos.
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="lista_filtrada_edocs.length > 0">
                    <v-col sm="12" md="10" lg="10" @click="dialog_edocs = !dialog_edocs">
                      <v-combobox v-model="lista_filtrada_edocs" label="Lista de Procesos" multiple persistent-hint
                        small-chips disabled color="green">
                      </v-combobox>
                    </v-col>
                  </v-row>


                </v-container>
              </v-card-text>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn small color="danger" @click="modal = false;">Cancelar</v-btn>
          <v-btn small color="success" @click="nueva_manifestacion">
            <v-icon>done</v-icon>Crear Manifestación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA ACTUALIZAR LA MANIFESTACIÓN-->
    <v-dialog v-model="modalManifestacion" max-width="50%" style=" z-index: 400 !important;">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="modalManifestacion = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Manifestación Electrónica</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md text-xs-center style="margin-top: -30px;">
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-container grid-list-md text-xs-center>
                  <v-row>
                    <v-col>
                      <v-label color="blue" elevation="1" text> <b>Nombre de Proceso:</b>
                        {{ model.nombre_proceso }}
                      </v-label>
                    </v-col>
                  </v-row>
                  <v-row v-if="rfc_agencia!=''">
                    <v-col sm="12" md="10" lg="10">
                      <v-autocomplete :hide-no-data="true" :items="clientes_agencia"
                        v-model="model_nuevo.rfc" :rules="[rules.required]" :item-text="getNombreCliente"
                        @change="set_rfc_cliente();" item-value="rfc" disabled
                        label="RFC de Cliente"></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="tiposManifestacion"
                        v-model="model.tipo_manifestacion" :rules="[rules.required]" item-text="nombre"
                        @change="set_coves_modelo" item-value="clave"
                        label="Seleccione Tipo de Manifestación de Valor"></v-autocomplete>
                    </v-col>

                    <v-col sm="12" md="4" lg="4">
                      <v-text-field v-model="model.tipo_cambio" label="Tipo de Cambio" maxlength="16"
                        :rules="[rules.required, validaFloat]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="model.momento_transmision == 'despues'">
                    <v-col sm="12" md="6" lg="6">
                    </v-col>
                    <v-col sm="12" md="6" lg="6">
                      <v-text-field label="Ejercicio fiscal del que se trata." type="text"
                        v-model="model.ejercicio_fiscal" maxlength="4"
                        :rules="model.momento_transmision == 'despues' ? [rules.required, validaEntero] : []"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="rfc_agencia==''">
                    <v-col sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="rfcs_consulta" v-model="model.rfc_consulta"
                        :rules="[rules.required]" :item-text="getNombreRfcConsulta" item-value="rfc" multiple
                        label="Seleccione RFCs de Consulta"></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="12" md="8" lg="8">
                      <v-autocomplete :hide-no-data="true" :items="representantes" v-model="model.rfc_representante"
                        :rules="[rules.required]" :item-text="getNombreRepresentante" item-value="rfc"
                        label="Seleccione Representante Legal"></v-autocomplete>
                    </v-col>
                  </v-row>
                 <!--  <v-row>
                    <v-col>
                      <v-autocomplete :hide-no-data="true" :items="representantes" v-model="model.terceros_autorizados"
                        :rules="[rules.required, validaTerceros]" :item-text="getNombreRepresentante" item-value="rfc"
                        label="Seleccione Personas Autorizadas para transmitir la manifestación"
                        multiple></v-autocomplete>
                    </v-col>
                  </v-row> -->
                   <v-row>
                      <v-col v-if="solicitudes.length > 0" sm="12" md="8" lg="8">
                                            <v-autocomplete :hide-no-data="true" :items="solicitudes" v-model="model.lista_solicitudes"
                                              item-text="descripcion" multiple @change="set_coves_modelo" item-value="descripcion"
                                              label="Agregar lista preguardada COVES/EDOCS"></v-autocomplete>
                                          </v-col>
                    </v-row>
                  <v-row row wrap>
                    <v-col sm="12" md="2" lg="2" @click="dialog2 = !dialog2">
                      <v-btn icon title="COVES Listado" v-tippy>
                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      Total de coves en la lista: <strong>{{ lista_filtrada_coves.length }}</strong>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="lista_filtrada_coves.length > 0">
                    <v-col sm="12" md="10" lg="10" @click="dialog2 = !dialog2">
                      <v-combobox v-model="lista_filtrada_coves" label="Lista de coves" multiple persistent-hint
                        small-chips disabled color="green">
                      </v-combobox>
                    </v-col>
                  </v-row>

                  <v-row row wrap>
                    <v-col sm="12" md="2" lg="2" @click="dialog1 = !dialog1">
                      <v-btn icon title="eDocuments Listado" v-tippy>
                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      Total de eDocuments en la lista: <strong>{{ lista_filtrada.length }}</strong>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="lista_filtrada.length > 0">
                    <v-col sm="12" md="10" lg="10" @click="dialog1 = !dialog1">
                      <v-combobox v-model="lista_filtrada" label="Lista de eDocuments" multiple persistent-hint
                        small-chips disabled color="green">
                      </v-combobox>
                    </v-col>
                  </v-row>

                  <v-row row wrap @click="dialog_edocs = !dialog_edocs">
                    <v-col sm="12" md="2" lg="2" >
                      <v-btn icon title="Proceso eDocuments Transmitidos" v-tippy >
                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      Agregar número de proceso de Edocuments transmitidos.
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="lista_filtrada_edocs.length > 0">
                    <v-col sm="12" md="10" lg="10" @click="dialog_edocs = !dialog_edocs">
                      <v-combobox v-model="lista_filtrada_edocs" label="Lista de Procesos" multiple persistent-hint
                        small-chips disabled color="green">
                      </v-combobox>
                    </v-col>
                  </v-row>

                </v-container>
              </v-card-text>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="danger" @click="modalManifestacion = false;">Cancelar</v-btn>
          <v-btn small color="success" @click="guardar_manifestacion">
            <v-icon>done</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";

import RefreshButton from "@/components/RefreshButton.vue";
import VistaPrevia from "@/views/manifestacion_valor/VistaPrevia.vue";

export default {
  components: { "v-refresh-button": RefreshButton, "v-vista-previa": VistaPrevia },

  data: () => ({
    clientes_agencia:[],
    rfc_agencia:"",
    manifestacion_seleccionada: "",
    solicitudes_manifestacion_actual: [],
    solicitudes: [],
    patentes: [],
    agentes_patentes: [],
    permisoPatentes: "",
    type_file: "",
    archivo_original: "",
    keyVistaPrevia: "",
    dialog1: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialogVP: false,
    dialog:false,
    dialog_edocs:false,
    fecha_de: "",
    fecha_a: "",
    fecha_factura: false,
    manifestacion_actual: "",
    id_manifestacion_actual: "",
    curp_actual: "",
    lista_coves_recuperacion: [],
    lista_edocs_recuperacion: [],
    lista_filtrada_edocs: [],
    dialogRecuperaciones: false,
    manifestacionSeleccionada: "",
    lista_filtrada: [],
    lista_filtrada_nuevo: [],
    lista_filtrada_coves: [],
    lista_filtrada_coves_nuevo: [],

    tiposManifestacion: [
      //{"clave":"global","nombre":"Global"},
      { "clave": "operacion", "nombre": "Por Operación" },
      { "clave": "operacion-consolidado", "nombre": "Por Operación-Consolidado" },
      //{"clave":"muestra","nombre":"Muestra Representantiva"},
    ],
    tiposMomentos: [
      { "clave": "previo", "nombre": "Previo al Despacho" },
      { "clave": "durante", "nombre": "Durante el Despacho" },
      //{"clave":"despues","nombre":"Después del Despacho"},
    ],
    model: {
      id: "",
      nombre_proceso: "",
      tipo_manifestacion: "",
      momento_transmision: "",
      lista_solicitudes: [],
      lista_edocuments: "",
      lista_coves: "",
      rfc_representante: "",
      terceros_autorizados: [],
      usuario_email: "",
      rfc_consulta: [],
      tipo_cambio: 0,
    },
    model_nuevo: {
      no_pedimento: "",
      fecha_pedimento: "",
      rfc: "",
      tipo_manifestacion: "",
      momento_transmision: "durante",
      lista_solicitudes: [],
      lista_edocuments: "",
      lista_coves: "",
      rfc_representante: "",
      terceros_autorizados: [],
      rfc_emisor: "",
      rfc_consulta: [],
      ejercicio_fiscal: "",
      tipo_cambio: 0,
    },
    model_nuevo_vacio: {
      no_pedimento: "",
      fecha_pedimento: "",
      rfc: "",
      tipo_manifestacion: "",
      momento_transmision: "durante",
      lista_solicitudes: [],
      lista_edocuments: "",
      lista_coves: "",
      rfc_representante: "",
      terceros_autorizados: [],
      rfc_emisor: "",
      ejercicio_fiscal: "",
    },
    nombresRfcConsulta: {},
    fab: false,
    menu1: false,
    menu2: false,
    menu3: false,
    file: "",
    ext_file: "",
    unidadesMedida: [],
    tiposMoneda: [],
    paises: [],
    modalPdfCove: false,
    modalPlantilla: false,
    idCoveVistaPrevia: "",
    detalle_factura: [],
    showImages: true,
    name: "datagrid",
    importData: [],
    nombre_proceso: "",
    modal: false,
    modalManifestacion: false,
    cliente: '',
    usuario: '',
    rfc: '',
    columns: [
      "id",
      "rfc",
      "nombre_proceso",
      "fecha_pedimento",
      "fecha_creado",
      //    "rfc_emisor",
      //    "usuario_email",
      "fecha_envio",
      //     "enviado_por",
      "json_consulta_response.eDocument",
      "estatus",
      //  "error",
      /*
       "errores",
       "xml",
       "pdf",
       "acuse",
       "evidencia",  */
      "actions",
      // "evidencias",
      //  "layout"
    ],
    options: {
      filterable: [
        "id",
        "rfc",
        "nombre_proceso",
        "fecha_pedimento",
        "fecha_creado",
        //      "rfc_emisor",
        "fecha_envio",
        //  "enviado_por",
        //    "usuario_email",
        "json_consulta_response.eDocument",
        "estatus",
        //   "error",
      ],
      sortable: [
        "id",
        "rfc",
        "nombre_proceso",
        "fecha_pedimento",
        "fecha_creado",
        //   "rfc_emisor",
        "fecha_envio",
        // "enviado_por",
        // "usuario_email",
        "json_consulta_response.eDocument",
        "estatus",
        // "error",
      ],

      headings: {
        id: "No. Proceso",
        rfc: "RFC",
        nombre_proceso: "Nombre de Proceso",
        // rfc_emisor: "RFC Emisor",
        fecha_creado: "Fecha del Proceso",
        fecha_pedimento: "Fecha Pedimento",
        fecha_envio: "Fecha de Envío",
        usuario_email: "Usuario",
        "json_consulta_response.eDocument": "Número Asignado",
        estatus: "Estatus",
        actions: "Operaciones",
        error: "Errores",
        errores: "Error Recuperación",
        //   xml: "XML",
        //  pdf: "PDF",
        //  acuse: "Acuse",
        //  evidencias: "Evidencias",
        //  layout: "Layout Manifestación"
      },
      uniqueKey: "id",
    },

    rules: {
      required: v => !!v || "Este campo es requerido",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Correo electrónico no valido";
      },
    },

    URL: "",
    show_loading: true,
    breadcrumbs: [{
      text: "Inicio",
      disabled: false,
      to: "/home"
    },
    {
      text: "EManifiesto",
      disabled: true,
      to: ""
    },
    {
      text: "Manifestación Electrónica",
      disabled: true,
      to: ""
    }
    ],
    emisores: [],
    rfcs_consulta: [],
    representantes: [],
    sellos: [],
    ws_password: '',

    registros: {
      selected: [],
      items: [],
    },
    facturas: {
      items: [],
      camposexcel: {
        "no_factura": "no_factura",
        "no_operacion": "no_operacion",
        "nombre_cove": "nombre_cove",
        "partidas": "partidas",
        "estatus": "estatus",
        "error": "error",
        "errores": "errores",
      },
    },
    columnsFacturas: [
      "no_factura",
      "no_operacion",
      "nombre_cove",
      "partidas",
      "estatus",
      "error",
      "errores",
      "xml",
      "pdf",
      "acuse",
    ],
    optionsFacturas: {
      filterable: [
        "no_factura",
        "no_operacion",
        "nombre_cove",
        "partidas",
        "estatus",
        "error",
      ],
      sortable: [
        "no_factura",
        "no_operacion",
        "nombre_cove",
        "partidas",
        "estatus",
        "error",
      ],
      headings: {
        no_factura: "Factura",
        o_operacion: "No. Operación",
        nombre_cove: "COVE",
        partidas: "Partidas",
        estatus: "Estatus",
        error: "Error Transmisión",
        errores: "Error Recuperación",
        xml: "XML",
        pdf: "PDF",
        acuse: "Acuse",
      }
    },
    dataRecuperaciones: [],
    columnsRecuperaciones: [
      "nombre",
      "tipo",
      "estatus",
      'fecha',
      "detalle",
      'error'
    ],
    optionsRecuperaciones: {
      filterable: [
        "nombre",
        "estatus",
        "tipo",
        "detalle",

      ],
      sortable: [
        "nombre",
        "estatus",
        "tipo",
        "detalle",
      ],
      headings: {
        nombre: "Archivo",
        estatus: "Estatus",
        tipo: "Origen",
        fecha: 'Fecha',
        detalle: "Archivo/Factura",
        error: 'Error'
      }
    },

    registro_seleccionado: '',

    headersExcel: [
      "Vinculación", "Incoterm", "eDocument", "COVE",
      "Número de Pedimento", "Patente", "Aduana-Seccion",
      //PRECIO PAGADO
      "Fecha Pagado", "Total Pagado en M.N.",
      "Forma de Pago Pagado", "Especifique Forma de Pago Pagado",
      "Clave Moneda Pagado", "Tipo Cambio Pagado",
      //PRECIO POR PAGAR
      "Fecha de Pago por Pagar", "Total por Pagar en M.N.",
      "Momentos o Situaciones de Pago", "Forma de Pago por Pagar", "Especifique Forma de Pago por Pagar",
      "Clave Moneda Por Pagar", "Tipo Cambio Por Pagar",
      //COMPENSÓ PAGO
      "Fecha de Pago Compenso Pago", "Prestación de la Mercancía", "Motivo por lo que se realizó",
      "Forma de Pago Compenso Pago", "Especifique Forma de Pago Compenso Pago",
      //
      "Método de Valoración Aduanera",
      //INCREMENTABLES
      "Tipo de Incrementable", "Fecha de Pago Incrementable",
      "Total Incrementable en M.N.", "¿Aplica cargo al importador?",
      "Clave Moneda Incrementable", "Tipo Cambio Incrementable",
      //DECREMENTABLES
      "Tipo de Decrementable", "Fecha de Pago Decrementable",
      "Total Decrementable en M.N.",
      "Clave Moneda Decrementable", "Tipo Cambio Decrementable",
      //VALOR EN ADUANA
      "Importe total del precio pagado en M.N.", "Importe total del precio por pagar en M.N.",
      "Importe total de incrementables en M.N.", "Importe total de decrementables en M.N.",
      "Importe total del valor en aduana en M.N."

    ],


    maxLen: {
      "RFC del Importador": 13,
      "RFC's de consulta": 13,
      "Vinculación": 1,
      "Incoterm": 11,
      "eDocument": 20,
      "COVE": 20,
      "Número de Pedimento": 20,
      "Patente": 20,
      "Aduana-Seccion": 20,
      //PRECIO PAGADO
      "Forma de Pago Pagado": 20, "Especifique Forma de Pago Pagado": 70, "Clave Moneda Pagado": 3,
      //PRECIO POR PAGAR
      "Momentos o Situaciones de Pago": 100, "Forma de Pago por Pagar": 20,
      "Especifique Forma de Pago por Pagar": 70, "Clave Moneda Por Pagar": 3,
      //COMPENSÓ PAGO
      "Prestación de la Mercancía": 1000, "Motivo por lo que se realizó": 1000,
      "Forma de Pago Compenso Pago": 20, "Especifique Forma de Pago Compenso Pago": 70,
      //
      "Método de Valoración Aduanera": 20,
      //INCREMENTABLES
      "Tipo de Incrementable": 20, "¿Aplica cargo al importador?": 1, "Clave Moneda Incrementable": 3,
      //DECREMENTABLES
      "Tipo de Decrementable": 20, "Clave Moneda Decrementable": 3,
      //VALOR EN ADUANA
    },
    camposObligatorios: {
      "Vinculación": "",
      "Incoterm": "",
      "COVE": "",
      //PRECIO PAGADO
      "Fecha Pagado": "", "Total Pagado en M.N.": "",
      "Forma de Pago Pagado": "", "Clave Moneda Pagado": "", "Tipo Cambio Pagado": "",
      //PRECIO POR PAGAR
      "Fecha de Pago por Pagar": "", "Total por Pagar en M.N.": "",
      "Momentos o Situaciones de Pago": "", "Forma de Pago por Pagar": "",
      "Clave Moneda Por Pagar": "", "Tipo Cambio Por Pagar": "",
      //COMPENSÓ PAGO
      "Fecha de Pago Compenso Pago": "", "Prestación de la Mercancía": "", "Motivo por lo que se realizó": "",
      "Forma de Pago Compenso Pago": "",
      //
      "Método de Valoración Aduanera": "",
      //INCREMENTABLES
      "Tipo de Incrementable": "", "Fecha de Pago Incrementable": "",
      "Total Incrementable en M.N.": "", "¿Aplica cargo al importador?": "",
      "Clave Moneda Incrementable": "", "Tipo Cambio Incrementable": "",
      //DECREMENTABLES
      "Tipo de Decrementable": "", "Fecha de Pago Decrementable": "",
      "Total Decrementable en M.N.": "",
      "Clave Moneda Decrementable": "", "Tipo Cambio Decrementable": "",
      //VALOR EN ADUANA
      "Importe total del precio pagado en M.N.": "", "Importe total del precio por pagar en M.N.": "",
      "Importe total de incrementables en M.N.": "", "Importe total de decrementables en M.N.": "",
      "Importe total del valor en aduana en M.N.": ""
    },
    fechasLayout: [
      "Fecha Pagado",
      "Fecha de Pago por Pagar",
      "Fecha de Pago Compenso Pago",
      "Fecha de Pago Incrementable",
      "Fecha de Pago Decrementable"
    ],
    importesLayout: [
      "Total Pagado en M.N.",
      "Total por Pagar en M.N.",
      "Total Incrementable en M.N.",
      "Total Decrementable en M.N.",
      "Importe total del precio pagado en M.N.",
      "Importe total del precio por pagar en M.N.",
      "Importe total de incrementables en M.N.",
      "Importe total de decrementables en M.N.",
      "Importe total del valor en aduana en M.N.",
      "Tipo Cambio Pagado",
      "Tipo Cambio Por Pagar",
      "Tipo Cambio Incrementable",
      "Tipo Cambio Decrementable"
    ],
    formasPagoLayout: [
      "Forma de Pago Pagado",
      "Forma de Pago por Pagar",
      "Forma de Pago Compenso Pago"
    ],
    clavesFormaPago: [
      "FORPAG.CC",
      "FORPAG.CH",
      "FORPAG.EF",
      "FORPAG.LC",
      "FORPAG.OT",
      "FORPAG.TE",
    ],
    clavesValoracion: [
      "VALADU.A78",
      "VALADU.VMI",
      "VALADU.VMS",
      "VALADU.VPU",
      "VALADU.VPV",
      "VALADU.VR",
      "VALADU.VTM",
    ],
    clavesIncrementables: [
      "INCRE.CE",
      "INCRE.CG",
      "INCRE.GS",
      "INCRE.GT",
      "INCRE.HM",
      "INCRE.MC",
      "INCRE.MP",
      "INCRE.RD",
      "INCRE.TI",
      "INCRE.VC",
    ],
    clavesDecrementables: [
      "DECRE.GR",
      "DECRE.GT",
      "DECRE.ID",
      "DECRE.PI",
      "DECRE.RC",
      "DECRE.RP",
    ],

  }),

  methods: {
    validaFloat: function(value) {
      if (value != null && value != "") {
        let stringValue = value.toString()
        let regex = /^\d*(\.\d*)?$/
        if (!stringValue.match(regex) && stringValue !== '') {
          return "Cantidad no valida";
        }
      }
      return true;
    },
    uploadLayoutMV: function (idManifestacion, proceso) {
      this.modalPlantilla = true;
      this.manifestacionSeleccionada = idManifestacion;
      this.nombre_proceso = proceso;
    },
    uploadFile: function () {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var rfc_file = this.$local_storage.get("rfc");
      var usuario_file = this.$local_storage.get("id_usuario");

      var keyFile = rfc_file + "/manifestacion/" + this.manifestacionSeleccionada + "/" + this.manifestacionSeleccionada + "_LAYOUT_MV.xlsx";
      var thisObj = this;
      var datos = {
        key: keyFile,
        bucket: "production.econnect.ds",
        type: this.type_file
      }

      axios.post(this.$hostname + 's3/upload_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var urlput = res.data.mensaje;
            //console.log(urlput);
            axios.put(urlput, this.archivo_original, {
              headers: {
                'Content-Type': this.type_file
              }
            })
              .then((res) => {
                thisObj.save_data_manifestacion();
              })
              .catch((error) => {
                this.$root.$dialogLoader.hide();
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                  footer: '',
                });
                console.log(error);
              });

          } else {
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
          this.$root.$dialogLoader.hide();
        });
    },
    save_data_manifestacion: function () {
      axios.post(this.URL + 'save_data_manifestacion/', { "id": this.manifestacionSeleccionada })
        .then((res) => {
          this.$root.$dialogLoader.hide();
          this.cargar();
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El layout se cargó correctamente. Puede transmitir la manifestación cuando lo requiera.",
            footer: '',
          });
          this.modalPlantilla = false;
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al cargar el layout. Favor de comunicarse con soporte.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
          this.$root.$dialogLoader.hide();
        });
    },
    validaDias: function () {
      if (this.fecha_de != "" && this.fecha_a != "") {
        var inicio = moment(this.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, "days");
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
        if (Math.abs(diferencia) > 365)
          return "Periodo máximo de consulta 365 dias. Favor de verificar.";
      }
      return true;
    },
    validaPedimento: function (val) {
      if (val != null && val != "") {
        if (!this.validarPatronPedimento(val))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      }
      return true;
    },
    validaPatentePermitida: function (val) {
      if (val != null && val != "" && this.permisoPatentes == "100" && this.agentes_patentes.length) {
        var split = val.split("-");
        try {
          console.log(split[1]);
          var patente = split[1].toString();
          if (!this.agentes_patentes.includes(patente))
            return "Patente no permitida. Revise su catálogo de agentes aduanales.";
        } catch (error) {
          return true;
        }

      }
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaFecha: function (fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida.";
      else
        return true;
    },
    validaAnio: function () {
      if (this.model_nuevo.fecha_de != "" && this.model_nuevo.fecha_a != "") {
        var inicio = moment(this.model_nuevo.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model_nuevo.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (inicio.year() > moment().year() || fin.year() > moment().year())
          return "Las fechas no deben ser mayor al año actual."
      }
      return true;
    },
    setListValues: function () {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.lista_edocuments);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
    },
    setListValuesProcesos: function () {
      this.lista_filtrada_edocs = [];
      let to_list = this.get_array_lista(this.model.lista_procesos);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_edocs.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_edocs.push(to_list[i]);
          this.getEdocsProcesos(to_list[i]);
        }
      }
    },
    setListValuesCoves: function () {
      this.lista_filtrada_coves = [];
      let to_list = this.get_array_lista(this.model.lista_coves);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_coves.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_coves.push(to_list[i]);
        }
      }
    },
    setListValuesNuevo: function () {
      this.lista_filtrada_nuevo = [];
      let to_list = this.get_array_lista(this.model_nuevo.lista_edocuments);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_nuevo.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_nuevo.push(to_list[i]);
        }
      }
    },
    setListValuesCovesNuevo: function () {
      this.lista_filtrada_coves_nuevo = [];
      let to_list = this.get_array_lista(this.model_nuevo.lista_coves);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_coves_nuevo.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_coves_nuevo.push(to_list[i]);
        }
      }
    },
    get_array_lista: function (cadena) {
      try {
        var newarr = [];
        if (cadena != undefined && typeof cadena == "string") {
          let data = cadena.split("\n");
          newarr = data.filter(a => a.trim() !== '');
          for (var i = 0; i < newarr.length; i++) {
            newarr[i] = newarr[i].trim();
            newarr[i] = newarr[i].replace(',', '');
            newarr[i] = newarr[i].replace('.', '');
          }
          return newarr;
        } else if (cadena != null && typeof cadena == "object")
          return cadena;

      } catch (error) {
        console.log(error);
      }
    },
    set_coves_modelo: function () {
      //de las referencias en model.lista_solicitudes obtener los coves y ponerlos en this.model.lista_coves
      //y mandar llamar el metodo de setListValuesCoves y setListValues
   //   if (this.model.tipo_manifestacion == "operacion") {//Si es por operación quitamos la lista de solicitudes
     //   this.model.lista_solicitudes = [];
     // }
      this.model.lista_coves = "";
      this.model.lista_edocuments = "";
      var solicitudes_seleccionadas = this.solicitudes.filter(e => { return this.model.lista_solicitudes.includes(e.descripcion) });
      for (var keysolicitud in solicitudes_seleccionadas) {
        if (solicitudes_seleccionadas[keysolicitud].tipo == "cove") {
          var str_cove = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model.lista_coves += str_cove;
        }
        else if (solicitudes_seleccionadas[keysolicitud].tipo == "edocument") {
          var str_edoc = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model.lista_edocuments += str_edoc;
        }
      }
      this.setListValuesCoves();
      this.setListValues();
    },
    set_coves_modelo_nuevo: function () {
      //de las referencias en model_nuevo.lista_solicitudes obtener los coves y ponerlos en this.model_nuevo.lista_coves
      //y mandar llamar el metodo de setListValuesCovesNuevo y setListValuesNuevo
   //   if (this.model_nuevo.tipo_manifestacion == "operacion") {//Si es por operación quitamos la lista de solicitudes
     //   this.model_nuevo.lista_solicitudes = [];
     // }
      this.model_nuevo.lista_coves = "";
      this.model_nuevo.lista_edocuments = "";
      var solicitudes_seleccionadas = this.solicitudes.filter(e => { return this.model_nuevo.lista_solicitudes.includes(e.descripcion) });
      for (var keysolicitud in solicitudes_seleccionadas) {
        if (solicitudes_seleccionadas[keysolicitud].tipo == "cove") {
          var str_cove = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model_nuevo.lista_coves += str_cove + "\n";
        }
        else if (solicitudes_seleccionadas[keysolicitud].tipo == "edocument") {
          var str_edoc = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model_nuevo.lista_edocuments += str_edoc + "\n";
        }
      }
      this.setListValuesCovesNuevo();
      this.setListValuesNuevo();
    },
    maxListaRule: function () {
      if (this.model.lista_edocuments == '' || this.model.lista_edocuments == undefined || Array.isArray(this.model.lista_edocuments)) {
        return "Lista vacia";
      }
      let x = this.model.lista_edocuments.split("\n");
      if (x.length > 50) {
        return "No se puede agregar más de 50 eDocs";
      }
      return true;
    },
    nueva_manifestacion() {
      if (!this.$refs.formnueva.validate()) {
        //Alguna operación o mensaje
      } else {

        var data = Vue.util.extend({}, this.model_nuevo);

        if (data.lista_coves == '' || data.lista_coves == null || data.lista_coves.length == 0) {
          this.$swal({
            type: "info",
            title: "¡Datos Incompletos!",
            text: "Ingrese al menos un cove.",
            footer: ""
          });
          return false;
        } else {
          data.lista_coves = this.get_array_lista(data.lista_coves);
        }

        if (data.lista_edocuments == '' || data.lista_edocuments == null || data.lista_edocuments.length == 0) {
          data.lista_edocuments = [];
        } else {
          data.lista_edocuments = this.get_array_lista(data.lista_edocuments);
        }

        if (data.ejercicio_fiscal == null || data.ejercicio_fiscal == "") {
          delete (data.ejercicio_fiscal);
        } else {
          data.ejercicio_fiscal = parseInt(data.ejercicio_fiscal);
        }

        var self = this;
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        axios({
          method: "post",
          url: this.URL + "nueva_manifestacion/",
          data: data
        })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "La manifestación se guardó correctamente.",
              footer: ""
            });
            this.modal = false;
            this.model_nuevo = this.model_nuevo_vacio;
            this.model_nuevo.rfc = this.$local_storage.get("rfc");
            this.model_nuevo.rfc_emisor = this.$local_storage.get("rfc");
            this.lista_filtrada_nuevo = [];
            this.lista_filtrada_coves_nuevo = [];

            //Se manda a recuperar edocs y coves
            if (response.data != undefined) {

              self.manifestacion_actual = response.data.nombre_proceso;
              self.id_manifestacion_actual = response.data.id;
              self.curp_actual = response.data.curp;
              self.lista_edocs_recuperacion = response.data.lista_edocuments;
              self.lista_coves_recuperacion = response.data.lista_coves;

            }
            this.cargar();

          })
          .catch(error => {
            var mensaje = "Ocurrió un error al guardar la manifestación";
            var tipo = "error";
            var footer = "";
            if (typeof error.response != undefined && error.response.data != undefined) {
              if (error.response.data.mensaje != undefined) {
                mensaje = error.response.data.mensaje;
              } else {
                for (var key in error.response.data) {
                  footer += "- " + key + ": " + error.response.data[key] + "<br>";
                }
              }
            }
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: footer,
            });
            this.$root.$dialogLoader.hide();
          });
      }
    },
    guardar_manifestacion() {

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {

        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        var data = Vue.util.extend({}, this.model);

        if (data.lista_edocuments == '' || data.lista_edocuments == null) {
          data.lista_edocuments == [];
        } else {
          data['lista_edocuments'] = this.get_array_lista(data['lista_edocuments']);
        }

        if (data.lista_coves == '' || data.lista_coves == null) {
          data.lista_coves = [];
        } else {
          data['lista_coves'] = this.get_array_lista(data['lista_coves']);
        }

        axios({
          method: "post",
          url: this.URL + "save_manifestacion/",
          data: data
        })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El proceso se ha guardado correctamente",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe una solicitud en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al guardar el proceso";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
            this.$root.$dialogLoader.hide();
          }).then(() => {
            this.modalManifestacion = false;
            this.cargar();
          });
      }
    },
    openModal: function (row) {
      this.cargarSolicitudes(row.id);
      this.model.id = row.id;
      this.model.rfc = row.rfc;
      if(this.rfc_agencia != ""){ //SI es agencia cargamos todo con el rfc del registro
        this.set_rfc_cliente(row.rfc);
      }
      this.model.nombre_proceso = row.nombre_proceso;
      this.model.tipo_manifestacion = row.tipo_manifestacion;
      this.model.momento_transmision = row.momento_transmision;
      //this.model.ejercicio_fiscal = row.ejercicio_fiscal;
      this.model.lista_solicitudes = row.lista_solicitudes;
      this.model.rfc_consulta = row.rfc_consulta;
      this.model.lista_edocuments = row.lista_edocuments;
      this.model.lista_coves = row.lista_coves;
      this.model.rfc_representante = row.rfc_representante;
      this.model.terceros_autorizados = row.terceros_autorizados;
      this.model.tipo_cambio = row.tipo_cambio;
      this.setListValuesCoves();
      this.setListValues();
      this.modalManifestacion = true;
    },
    validaEntero(numero) {
      if (numero != null) {
        const pattern = /^[\d]*$/;
        if (pattern.test(numero) && numero.length == 4) {
          if (numero > moment().year())
            return "El año no debe ser mayor al año actual"
          else
            return true;
        }
        else
          return "Ingrese un año válido";
      }
      return true;
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateExcel(excelDate) {
      try {
        if (!excelDate) return false;
        var fecha = '';
        if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
          fecha = moment(String(excelDate)).format("YYYY-MM-DD");
        else
          fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
        if (fecha == 'Invalid date') return false;
        return fecha;
      } catch (error) {
        return false;
      }
    },
    cargar: function () {

      //  if (!this.$refs.formreporte.validate()) {
      //Alguna operación o mensaje
      //   console.log('entra aqui');
      //  } else {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      let fecha = 0;
      if (this.fecha_factura)
        fecha = 1;
      var datos = {
        rfc: this.rfc,
        fecha_de: this.fecha_de,
        fecha_a: this.fecha_a,
        fecha_pedimento: fecha,
        rfc_agencia: this.rfc_agencia
      };

      axios
        .post(this.URL + "get_manifestacion/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.registros.items = res.data;
            this.registros.items.sort(function (a, b) {
              //Ordenar por id más reciente
              return b.id - a.id;
            });
            for (var k in this.registros.items) {
              //Si tiene estatus 1 - Transmitido, entonces mandamos llamar el metodo de consultar la operacion
              if (this.registros.items[k].estatus == 1 && this.registros.items[k].json_transmision_response && this.registros.items[k].json_transmision_response.numeroOperacion) {
                this.consultar_operacion(this.registros.items[k].id);
              }
              if (this.registros.items[k].estatus == 5 ) {
                this.consultar_operacion(this.registros.items[k].id);
              }
              this.registros.items[k].fecha_creado = this.parseDate(this.registros.items[k].fecha_creado);
              this.registros.items[k].fecha_pedimento = this.parseDate(this.registros.items[k].fecha_pedimento);
              this.registros.items[k].fecha_envio = this.parseDate(this.registros.items[k].fecha_envio);
              this.registros.items[k].estatus = this.getEstatus(this.registros.items[k], this.registros.items[k].estatus);
              this.registros.items[k].lista_edocs_recuperaciones = this.registros.items[k].lista_edocuments;
              this.registros.items[k].lista_coves_recuperaciones = this.registros.items[k].lista_coves;
              this.registros.items[k].lista_edocuments = this.getCadena(this.registros.items[k].lista_edocuments);
              this.registros.items[k].lista_coves = this.getCadena(this.registros.items[k].lista_coves);


            }
          }
        })
        .catch(err => {

          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
      // }

    },
    getCadena: function (arr) {
      if (arr != null && typeof arr == "object") {
        var cadena = ""
        for (var k in arr) {
          cadena += arr[k]["nombre"].toString() + "\n";
        }
        return cadena;
      } else
        return arr;
    },
    getEstatus: function (Datos, estatus) {
      var arr_estatus = ["Sin transmitir", "Transmitido correctamente", "Transmitido con errores", "Transmitiendo", "Transmitido y Consultado", "Pendiente de aceptación", "Rechazada"];
      if (estatus in arr_estatus) {
        if (arr_estatus[estatus] == "Sin transmitir" && (Datos.rfc_representante == null || Datos.rfc_representante == ""))
          return "Completar registro";
        else if (arr_estatus[estatus] == "Sin transmitir" && Datos.datosManifestacionValor == 0)
          return "Pagos no cargados";
        else
          return arr_estatus[estatus];
      }
      else
        return "N/A";
    },
    getEstatusDetalle: function (estatus) {
      var arr_estatus = ["Pendiente", "Transmitido", "Aceptado", "Rechazado"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      var nombre = file.name.split(".")
      this.ext_file = nombre[nombre.length - 1];
      this.type_file = file.type;
      this.archivo_original = file;

      if (isLt2M) {
        const fr = new FileReader()
        fr.readAsDataURL(file)

        fr.addEventListener('load', () => {
          this.file = fr.result; // this is an image file that can be sent to server...
          var n = this.file.search("base64,");
          //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
          if (n >= 0) {
            this.file = this.file.substring(n + 7);
          }
        });
        return true;
      }
      this.$swal({
        type: "warning",
        title: "¡Operación no Permitida!",
        text: "El archivo no debe ser mayor a 2MB.",
        footer: ""
      });
      return false;
    },
    verificaObligatorios: function (results) {
      var errores = '';
      var keys = [];
      for (var k in results) {
        keys.push(k);
      }
      console.log("keys: ", keys);
      for (var key in this.camposObligatorios) {
        if (keys.indexOf(key) == -1)
          errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
      }

      return errores == '' ? true : errores;
    },
    verificaMaxlen: function (results) {
      var errores = '';

      for (var key in this.maxLen) {
        if (key == "RFC's de consulta" && results[key] != null) {
          var rfcs = results["RFC's de consulta"].split(",");
          for (var r in rfcs) {
            if (rfcs[r].toString().trim().length > this.maxLen[key]) {
              errores += '<br/>' + "- El campo " + key + ":'" + rfcs[r].toString().trim() +
                "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
            }
          }
        }
        else if (key == "eDocument" && results[key] != null) {
          var edocs = results["eDocument"].toString().split(",");
          for (var r in edocs) {
            if (edocs[r].toString().trim().length > this.maxLen[key]) {
              errores += '<br/>' + "- El campo " + key + ":'" + edocs[r].toString().trim() +
                "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
            }
          }
        } else {
          if (results[key] != null && results[key].toString().trim().length > this.maxLen[key]) {
            errores += '<br/>' + "- El campo " + key + ":'" + results[key].toString().trim() +
              "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
          }
        }

      }

      return errores == '' ? true : errores;
    },
    validaCorreo: function (mail) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(mail);
    },
    cargarRfcsConsulta: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.rfcs_consulta = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los rfcs de consulta.",
            footer: ""
          });
        });
    },
    getNombreRfcConsulta: function (record) {
      return record.rfc + " - " + record.nombre + " - " + record.patente;
    },
    cargarEmisores: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.emisores = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los emisores.",
            footer: ""
          });
        });
    },
    getNombreEmisor: function (record) {
      return record.rfc + " - " + record.razon_social;
    },
    cargarRepresentantes: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/representantes/get_representantes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.representantes = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los representantes legales.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getNombreCliente: function (record) {
      return record.rfc + " - " + record.razon_social;
    },
    getNombreRepresentante: function (record) {
      return record.rfc + " - " + record.nombre + " " + record.apellido_paterno + " " + record.apellido_materno;
    },
    cargarSolicitudes: function (id_manifestacion = 0) {
      if (id_manifestacion == 0) {
        var datos = {
          rfc: this.model.rfc
        };
      } else {
        var datos = {
          rfc: this.model.rfc,
          id_manifestacion: id_manifestacion
        };
      }

      axios
        .post(this.$hostname + "vucem/get_solicitudes_manifestacion/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.solicitudes = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las solicitudes de recuperación.",
            footer: ""
          });
        });
    },
    validaTerceros() {
      if (this.model.terceros_autorizados != null && this.model.terceros_autorizados.length == 0) {
        return "Debe seleccionar al menos una persona autorizada";
      }
      return true;
    },
    validaTercerosNuevo() {
      if (this.model_nuevo.terceros_autorizados != null && this.model_nuevo.terceros_autorizados.length == 0) {
        return "Debe seleccionar al menos una persona autorizada";
      }
      return true;
    },
    cargarCertificados: function () {
      var rfc = this.rfc;
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/certificados/list_certificados/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.sellos = res.data;
            if (this.sellos.length > 0) {
              var search = this.sellos.filter(function (e) {
                return e.estatus == 1 && e.activo == true; //1-Sello correcto
              });
              if (search.length > 0) {
                let sello = search[0];
                this.ws_password = sello.clave_ws;
              } else {
                var search2 = this.sellos.filter(function (e) {
                  return e.estatus == 0 && e.activo == true; //0-Sello sin probar
                });
                if (search2.length > 0) {
                  let sello = search2[0];
                  this.ws_password = sello.clave_ws;
                } else {
                  this.$swal({
                    type: "warning",
                    title: "Advertencia",
                    text: "El cliente: " + rfc + " no tiene sellos digitales validados. Favor de verificar.",
                    footer: ""
                  });

                }
              }
            } else {
              this.$swal({
                type: "warning",
                title: "Advertencia",
                text: "No se han configurado sellos digitales para el cliente: " + rfc,
                footer: ""
              });
            }
          }
        })
        .catch(err => {

        });
    },

    verificaEmisor: function (emisor, opcion) {
      if (emisor == undefined)
        return false;

      var search = this.emisores.filter(function (e) {
        return e.rfc.toString().trim().toUpperCase() == emisor.toString().trim().toUpperCase();
      });
      if (opcion == 'domicilio')
        return search.length > 0 ? search[0] : '';
      else
        return search.length > 0;
    },
    formatNumber: function (numero, decimales) {
      if (numero == undefined || numero == null || numero == "")
        numero = 0;
      numero = Number(numero);
      if (isNaN(numero)) {
        return "";
      } else
        return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    //Validamos números Float con punto decimal y que cumpla con el número de decimales
    verificaDecimales: function (valor, numeroDecimales) {
      var cantidad_split = valor.toString().split(".");
      if (cantidad_split.length == 1) {
        if (Number.isNaN(parseInt(cantidad_split[0]))) {
          return false;
        } else
          return parseInt(cantidad_split[0]).toString() + "." + "0".repeat(numeroDecimales);
      } else if (cantidad_split.length == 2) {
        if (Number.isNaN(parseInt(cantidad_split[0])) || Number.isNaN(parseInt(cantidad_split[1]))) {
          return false;
        } else if (cantidad_split[1].toString().length > numeroDecimales) {
          var newNum = Math.round(valor * Math.pow(10, numeroDecimales)) / Math.pow(10, numeroDecimales);
          return this.verificaDecimales(newNum, numeroDecimales);
        } else {
          var repetir = numeroDecimales - cantidad_split[1].toString().length;
          if (repetir == 0)
            return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString();
          else
            return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString() + "0".repeat(repetir);

        }

      } else
        return false;
    },

    validaCargaLayout: async function (results) {
      var thisObject = this;
      var errores = 0;
      var erroresText = '';
      var errorTmp = '';
      var rfc = thisObject.rfc;

      try {
        if (results.length == 0) {
          errores++;
          erroresText += "No hay datos en el layout. Verifique que exista información del 6to renglón en adelante.";
        } else {
          for (var k in results) {

            var obligatorios = thisObject.verificaObligatorios(results[k]);
            if (obligatorios !== true) {
              errores++;
              if (erroresText.indexOf(obligatorios) == -1)
                erroresText += obligatorios;
            } else {
              var maxlen = thisObject.verificaMaxlen(results[k]);
              if (maxlen !== true) {
                errores++;
                if (erroresText.indexOf(maxlen) == -1)
                  erroresText += maxlen;
              }

              /*if (results[k]["RFC's de consulta"] != null) {
                if (results[k]["RFC's de consulta"].toString().trim() != '')
                  results[k]["RFC's de consulta"] = results[k]["RFC's de consulta"].toString().trim().split(",");
                else
                  results[k]["RFC's de consulta"] = null;
              }*/
              if (results[k]["eDocument"] != null) {
                if (results[k]["eDocument"].toString().trim() != '')
                  results[k]["eDocument"] = results[k]["eDocument"].toString().trim().split(",");
                else
                  results[k]["eDocument"] = null;
              }
              var vincula = results[k]["Vinculación"];
              results[k]["Vinculación"] = parseInt(results[k]["Vinculación"]);
              if (!Number.isInteger(results[k]["Vinculación"]) || (results[k]["Vinculación"] != 1 && results[k]["Vinculación"] != 0)) {
                errores++;
                errorTmp = "<br>- Vinculación no válida: \"" + vincula + "\", debe ser un número (0 o 1).";
                if (erroresText.indexOf(errorTmp) == -1)
                  erroresText += errorTmp;
              }
              var aplica = results[k]["¿Aplica cargo al importador?"]
              results[k]["¿Aplica cargo al importador?"] = parseInt(results[k]["¿Aplica cargo al importador?"]);
              if (!Number.isInteger(results[k]["¿Aplica cargo al importador?"]) || (results[k]["¿Aplica cargo al importador?"] != 1 && results[k]["¿Aplica cargo al importador?"] != 0)) {
                errores++;
                errorTmp = "<br>- ¿Aplica cargo al importador? no válida: \"" + aplica + "\", debe ser un número (0 o 1).";
                if (erroresText.indexOf(errorTmp) == -1)
                  erroresText += errorTmp;
              }

              if (results[k]["Número de Pedimento"] != null || results[k]["Patente"] != null || results[k]["Aduana-Seccion"] != null) {
                if (results[k]["Número de Pedimento"] == null || results[k]["Patente"] == null || results[k]["Aduana-Seccion"] == null) {
                  errores++;
                  errorTmp = "<br>- Se deben ingresar las 3 partes del número de pedimento o ninguna.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                }
              }

              for (var keyFecha in thisObject.fechasLayout) {
                var fecha = thisObject.fechasLayout[keyFecha];
                var fechaOrig = results[k][fecha];
                results[k][fecha] = thisObject.parseDateExcel(fechaOrig);
                if (results[k][fecha] == false) {
                  errores++;
                  errorTmp = '<br/>' + "- La " + fecha + " '" + fechaOrig + "' no es una fecha válida.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                }
              }

              for (var keyImporte in thisObject.importesLayout) {
                var importe = thisObject.importesLayout[keyImporte];
                if (thisObject.verificaDecimales(results[k][importe], 3) === false) {
                  errores++;
                  errorTmp = "<br>- " + importe + " no válido: " + results[k][importe] + ", debe ser un número válido con 3 decimales.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                } else
                  results[k][importe] = thisObject.verificaDecimales(results[k][importe], 3);
              }

              for (var keyForma in thisObject.formasPagoLayout) {
                var forma = thisObject.formasPagoLayout[keyForma];
                if (thisObject.clavesFormaPago.indexOf(results[k][forma]) == -1) {
                  errores++;
                  errorTmp = "<br>- La forma de pago '" + results[k][forma] + "' no se encuentra en el catálogo de formas de pago.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                }
              }

              if (results[k]["Forma de Pago Pagado"] == "FORPAG.OT") {
                if (results[k]["Especifique Forma de Pago Pagado"] == null) {
                  errores++;
                  errorTmp = "<br>- 'Especifique Forma de Pago Pagado' no debe estar vacío si seleccionó la forma de pago FORPAG.OT.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                }
              }
              if (results[k]["Forma de Pago por Pagar"] == "FORPAG.OT") {
                if (results[k]["Especifique Forma de Pago por Pagar"] == null) {
                  errores++;
                  errorTmp = "<br>- 'Especifique Forma de Pago por Pagar' no debe estar vacío si seleccionó la forma de pago FORPAG.OT.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                }
              }
              if (results[k]["Forma de Pago Compenso Pago"] == "FORPAG.OT") {
                if (results[k]["Especifique Forma de Pago Compenso Pago"] == null) {
                  errores++;
                  errorTmp = "<br>- 'Especifique Forma de Pago Compenso Pago' no debe estar vacío si seleccionó la forma de pago FORPAG.OT.";
                  if (erroresText.indexOf(errorTmp) == -1)
                    erroresText += errorTmp;
                }
              }

              if (thisObject.clavesValoracion.indexOf(results[k]["Método de Valoración Aduanera"]) == -1) {
                errores++;
                errorTmp = "<br>- El Método de Valoración Aduanera '" + results[k]["Método de Valoración Aduanera"] + "' no se encuentra en el catálogo de metodos de valoración.";
                if (erroresText.indexOf(errorTmp) == -1)
                  erroresText += errorTmp;
              }

              if (thisObject.clavesIncrementables.indexOf(results[k]["Tipo de Incrementable"]) == -1) {
                errores++;
                errorTmp = "<br>- El Tipo de Incrementable '" + results[k]["Tipo de Incrementable"] + "' no se encuentra en el catálogo de tipos de incrementables.";
                if (erroresText.indexOf(errorTmp) == -1)
                  erroresText += errorTmp;
              }
              if (thisObject.clavesDecrementables.indexOf(results[k]["Tipo de Decrementable"]) == -1) {
                errores++;
                errorTmp = "<br>- El Tipo de Decrementable '" + results[k]["Tipo de Decrementable"] + "' no se encuentra en el catálogo de tipos de decrementables.";
                if (erroresText.indexOf(errorTmp) == -1)
                  erroresText += errorTmp;
              }


            }
            //console.log("Key is " + k + ", value is" + results[k]);
          }

        }

        return ({
          "errores": errores,
          "erroresText": erroresText
        });

      } catch (error) {
        //console.log(error);
        return ({
          "errores": 1,
          "erroresText": error.message
        });
      }

    },
    handleSuccess: async function ({ results, header }) {
      try {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let validaciones = await this.validaCargaLayout(results);
        if (validaciones.errores > 0) {
          this.$swal({
            type: "warning",
            title: "¡Operación no Permitida!",
            text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
            footer: validaciones.erroresText,
          });
          this.$root.$dialogLoader.hide();
        } else {
          this.uploadFile();
        }

      } catch (error) {
        this.$swal({
          type: "warning",
          title: "¡Operación no Permitida!",
          text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
          footer: error.message,
        });
        this.$root.$dialogLoader.hide();
      }
    },

    SimularTransmision: function (row_id) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let datos = {
        id: row_id,
      };
      axios
        .post(this.$hostname + "vucem/simular_manifestacion/", datos)
        .then(() => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "Se ha iniciado el proceso de simulación correctamente.",
            footer: ""
          });
        })
        .catch(err => {

          var errores = "";
          if (err.response.data != undefined) {
            if (err.response.data.mensaje != undefined) {
              if (typeof err.response.data.mensaje == "string")
                errores += err.response.data.mensaje;
              else
                errores += err.response.data.mensaje[0];

            } else {
              Object.keys(err.response.data).forEach(function (key) {
                errores += key + ": " + err.response.data[key];
                errores += "<br>";
              });

            }
          }
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al intentar simular la transmisión. Favor de intentar más tarde.",
            footer: errores
          });
        })
        .then(() => {
          this.cargar();
          this.$root.$dialogLoader.hide();
        });
    },
    transmitir: async function (row_id, estatus) {
      let respuesta= true;

      if(estatus == 'Pagos no cargados' || estatus == "Sin transmitir" || estatus == 'Transmitido con errores')
           await this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro trnasmitir la manifestación sin información cargada con No. Proceso " + row_id + "?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Si",
              cancelButtonText: "No"
            }).then(result => {

                  respuesta = result.value;

            });
            console.log(respuesta);
      if(respuesta){
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let datos = {
        id_manifestacion: row_id,
        usuario: this.usuario,
        id_cliente: this.cliente,
        rfc: this.rfc,
      };
      axios
        .post(this.$hostname + "manifestacion/transmitir_nuevo/", datos)
        .then(() => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "Se ha iniciado el proceso de transmisión. Recibirá una notificación cuando el resultado esté disponible.",
            footer: ""
          });
        })
        .catch(err => {

          var errores = "";
          if (err.response.data != undefined) {
            if (err.response.data.mensaje != undefined) {
              if (typeof err.response.data.mensaje == "string")
                errores += err.response.data.mensaje;
              else
                errores += err.response.data.mensaje[0];

            } else {
              Object.keys(err.response.data).forEach(function (key) {
                errores += key + ": " + err.response.data[key];
                errores += "<br>";
              });

            }
          }
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al intentar transmitir la manifestación.",
            footer: errores
          });
        })
        .then(() => {
          this.cargar();
          this.$root.$dialogLoader.hide();
        });
      }
    },

    consultar_operacion: function (row_id) {
      let datos = { id_manifestacion: row_id };
      axios
        .post(this.$hostname + "manifestacion/consultar_nuevo/", datos)
        .then(() => {

        })
        .catch(err => {
          console.log(err);
        });
    },
    cancelRegistro: function (id) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de cancelar la manifestación con No. Proceso " + id + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
              "id_manifestacion": id,
              "user_updated": this.usuario,
              "rfc": this.rfc
          };
          axios.post(this.URL + "eliminar_manifestacion/", datos)
            .then(res => {

              this.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se cancelo correctamente.",
                footer: ""
              });

            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al cancelar el registro.",
                footer: ""
              });
              console.log(err);
            }).then(() => {
              this.cargar();
              this.$root.$dialogLoader.hide();
            });
        }
      })
    },

    regenerapdfs: function (id) {

          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_manifestacion: id
          };
          axios.post(this.URL + "generar_documentos_manifestacion/", datos)
            .then(res => {

              this.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se regenero correctamente.",
                footer: ""
              });

            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al regenerar el registro.",
                footer: ""
              });
              console.log(err);
            }).then(() => {
              this.cargar();
              this.$root.$dialogLoader.hide();
            });

    },
    deleteRegistro: function (id) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar la manifestación con No. Proceso " + id + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: id
          };
          axios.post(this.URL + "elimina_manifestacion/", datos)
            .then(res => {

              this.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se eliminó correctamente.",
                footer: ""
              });

            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el registro.",
                footer: ""
              });
              console.log(err);
            }).then(() => {
              this.cargar();
              this.$root.$dialogLoader.hide();
            });
        }
      })
    },
    consulta_pedimento: function (idManifestacion) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: idManifestacion,
      };
      axios.post(this.URL + "consulta_pedimento_manifestacion/", datos)
        .then(res => {
          var mensaje = "La manifestación se actualizó correctamente.";
          if (typeof res.data !== "undefined" && res.data.mensaje != undefined) {
            mensaje = res.data.mensaje;
          }
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: mensaje,
            footer: '',
          });
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          var mensaje = "Ocurrió un error al consultar el pedimento de la manifestación. Favor de intentar más tarde.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            mensaje = error.response.data.mensaje;
          }
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          this.$root.$dialogLoader.hide();
          console.log(error);
        });
    },
    downloadZipEvidencia: function (idManifestacion, intento = 0) {
      var nombreZip = idManifestacion.toString() + "_evidencias.zip";
      var key = this.$local_storage.get("rfc") + "/reportes/" + nombreZip;
      var datoss3 = {
        id: key,
        bucket: "production.econnect.ds"
      }

      var thisObj = this;
      axios.post(this.$hostname + 's3/download_url/', datoss3)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);
            this.$root.$dialogLoader.hide();
          } else {
            if (intento > 3) {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al generar ZIP. Favor de intentar nuevamente.",
                footer: '',
              });
              this.$root.$dialogLoader.hide();
            } else {
              setTimeout(function () {
                thisObj.downloadZipEvidencia(idManifestacion, intento + 1);
              }, 10000); //Damos tiempo para generar el zip (10 seg)
            }

          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;

          if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 3) {
            setTimeout(function () {
              thisObj.downloadZipEvidencia(idManifestacion, intento + 1);
            }, 10000); //Damos tiempo para generar el zip (10 seg)
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            console.log(error);
            this.$root.$dialogLoader.hide();
          }
        });

    },
    generaZipEvidencia: function (idManifestacion) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        rfc: this.$local_storage.get("rfc"),
        id_manifestacion: idManifestacion,
        reporte_url: "/reportes_vucem/zip_evidencias_manifestacion/",
        nombre_reporte: "Zip Evidencias Manifestacion",
        tipo: "ZIP_Evidencias_Manifestacion",
        usuario: this.$local_storage.get("id_usuario"),
      };
      var thisObj = this;
      axios.post(this.$hostname + "reportes/save_reporte/", datos)
        .then(res => {
          setTimeout(function () {
            thisObj.downloadZipEvidencia(idManifestacion, 1);
          }, 10000); //Damos tiempo para generar el zip (10 seg)
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
          } else {//Si es un timeout intentamos descargar el archivo
            setTimeout(function () {
              thisObj.downloadZipEvidencia(idManifestacion, 1);
            }, 10000); //Damos tiempo para generar el zip (10 seg)
          }
          console.log(error);
        });
    },
    downloadLayoutMV: function (idManifestacion, intento = 0) {

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      if (intento == 0) {//Se generara siempre
        this.generaLayoutMV(idManifestacion);
      } else {
        var nombreKey = idManifestacion.toString() + "_LAYOUT_MV.xlsx";
        var key = this.$local_storage.get("rfc") + "/manifestacion/" + idManifestacion + "/" + nombreKey;
        var datoss3 = {
          id: key,
          bucket: "production.econnect.ds"
        }

        axios.post(this.$hostname + 's3/download_url/', datoss3)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = res.data.mensaje;
              a.target = '_blank';
              a.click();
              a.parentNode.removeChild(a);
              this.$root.$dialogLoader.hide();
            } else {
              if (intento > 4) {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar el layout. Favor de intentar nuevamente.",
                  footer: '',
                });
                this.$root.$dialogLoader.hide();
              } else {
                setTimeout(() => { this.downloadLayoutMV(idManifestacion, intento + 1); }, 4000);
              }

            }
          })
          .catch((error) => {
            var mensaje = "Ocurrió un error al descargar el archivo";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;

            if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
              setTimeout(() => { this.downloadLayoutMV(idManifestacion, intento + 1); }, 4000);
            } else {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
              this.$root.$dialogLoader.hide();
            }
          });
      }
    },

    generaLayoutMV: function (idManifestacion) {
      var datos = {
        id: idManifestacion,
      };
      axios.post(this.URL + "procesar_layout/", datos)
        .then(res => {
          this.downloadLayoutMV(idManifestacion, 1);
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            this.$root.$dialogLoader.hide();
          } else {//Si es un timeout intentamos descargar el archivo
            this.downloadLayoutMV(idManifestacion, 1);
          }
          console.log(error);
        });
    },
    downloadLayoutAyuda: function (key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "descargas.econnectpro.mx"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            //a.download = name[name.length - 1];
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    downloadFile: function (key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      let nombre_download = key.split("/").pop();

      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    downloadVistaPrevia: function (row, intento = 0) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      if (intento == 0) {//Se generara siempre, ya que pueden actualizar el alyout y para que se descargue actualizada
        this.generaVistaPrevia(row);
      } else {
        var key = row.rfc + "/manifestacion/" + row.id.toString() + "/" + row.id.toString() + "_vista_previa.pdf";
        var datoss3 = {
          id: key,
          bucket: "production.econnect.ds"
        }
        let nombre_download = key.split("/").pop();

        axios.post(this.$hostname + 's3/download_url/', datoss3)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = res.data.mensaje;
              a.target = '_blank';
              a.click();
              a.parentNode.removeChild(a);
              this.$root.$dialogLoader.hide();
            } else {
              if (intento > 4) {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar vista previa. Favor de intentar nuevamente.",
                  footer: '',
                });
                this.$root.$dialogLoader.hide();
              } else {
                this.downloadVistaPrevia(row, intento + 1);
              }

            }
          }).catch((error) => {
            var mensaje = "Ocurrió un error al descargar el archivo";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;

            if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
              this.downloadVistaPrevia(row, intento + 1);
            } else {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
              this.$root.$dialogLoader.hide();
            }
          });
      }

    },
    generaVistaPrevia: function (row) {
      var datos = {
        id: row.id,
      };
      axios.post(this.URL + "pdf_acuse_detalle_preview/", datos)
        .then(res => {
          this.downloadVistaPrevia(row, 1);
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            this.$root.$dialogLoader.hide();
          } else {//Si es un timeout intentamos descargar el archivo
            this.downloadVistaPrevia(row, 1);
          }
          console.log(error);
        });
    },
    downloadFormatoE2: function (row, intento = 0) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      if (intento == 0) {//Se generara siempre, ya que pueden actualizar el layout y para que se descargue actualizado
        this.generaFormatoE2(row);
      } else {
        var key = row.rfc + "/manifestacion/" + row.id.toString() + "/" + row.id.toString() + "_e2.pdf";
        var datoss3 = {
          id: key,
          bucket: "production.econnect.ds"
        }
        let nombre_download = key.split("/").pop();
        var thisObj = this;
        axios.post(this.$hostname + 's3/download_url/', datoss3)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = res.data.mensaje;
              a.target = '_blank';
              a.click();
              a.parentNode.removeChild(a);
              this.$root.$dialogLoader.hide();
            } else {
              if (intento > 4) {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar vista previa. Favor de intentar nuevamente.",
                  footer: '',
                });
                this.$root.$dialogLoader.hide();
              } else {
                setTimeout(function () {
                  thisObj.downloadFormatoE2(row, intento + 1);
                }, 10000); //Damos tiempo para generar el zip (10 seg)
              }

            }
          }).catch((error) => {
            var mensaje = "Ocurrió un error al descargar el archivo";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;

            if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
              setTimeout(function () {
                thisObj.downloadFormatoE2(row, intento + 1);
              }, 10000); //Damos tiempo para generar el zip (10 seg)
            } else {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
              this.$root.$dialogLoader.hide();
            }
          });
      }

    },
    generaFormatoE2: function (row) {
      var datos = {
        id: row.id,
      };
      axios.post(this.URL + "generar_pdf_e2/", datos)
        .then(res => {
          this.downloadFormatoE2(row, 1);
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            this.$root.$dialogLoader.hide();
          } else {//Si es un timeout intentamos descargar el archivo
            this.downloadFormatoE2(row, 1);
          }
          console.log(error);
        });
    },
    cargarDetalleFactura: function (idCove) {
      this.$swal({
        type: "info",
        title: "Operación No Disponible",
        text: "Está función aún no se ha desarrollado",
        footer: ""
      });
      return false;

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      this.idCoveVistaPrevia = idCove;
      var datos = {
        id_cove: idCove
      };
      axios
        .post(this.URL + "get_detalle_factura_coves/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.detalle_factura = res.data.detalle;
            this.nombresRfcConsulta = res.data.nombres;
            this.modalPdfCove = true;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el detalle del cove. Favor de comunicarse con soporte.",
            footer: ""
          });
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    vistaPrevia: function (id, nombre_proceso) {
      this.$local_storage.set("id_manifestacion", id);
      this.$local_storage.set("nombre_manifestacion", nombre_proceso);
      this.keyVistaPrevia = nombre_proceso + "-" + moment().format("YYYYMMDD-HH:mm:ss");
      this.dialogVP = true;
    },
    getRecuperaciones: function (row) {
      let self = this;

      this.manifestacion_actual = row.nombre_proceso;
      this.id_manifestacion_actual = row.id;
      this.curp_actual = row.curp;
      let b = row.lista_coves_recuperaciones;
      let c = row.lista_edocs_recuperaciones;

      this.getDetalleDocumentos(b, c, row);


    },
    GetidSellos(curp) {

      var patentes = this.patentes;
      const ix = patentes.findIndex(c => c.curp === curp);
      if (ix >= 0)
        return patentes[ix].id;
      else
        return 0;

    },
    getPatentes: function () {
      let self = this;
      var data = {
        cliente: this.$local_storage.get("rfc"),
      };
      axios
        .post(
          this.$hostname + "catalogos/certificados/list_certificados_agentes/",
          data
        )
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.patentes = res.data;

          }
        })
        .catch(err => {

          console.log(err);
        });
    },
     getEdocsProcesos: async function (numero) {
      let self = this;
      var data = {
        rfc: this.$local_storage.get("rfc"),
        nombre_proceso: numero
      };
      await axios
        .post( this.$hostname + "manifestacion/buscar_edocuments_transmitidos/", data )
        .then(res => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            res.data.forEach(element => {
              console.log(element);
              this.model_nuevo.lista_edocuments += element + "\n";
              this.model.lista_edocuments += element + "\n";
            });

          }
        })
        .catch(err => {
          console.log(err);
        });
        this.setListValuesNuevo();
         this.setListValues();

    },

    getDetalleDocumentos: function (b, c, row) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let self = this;
      let estatus = ["Pendiente", "Recuperado", "No Recuperado"];
      let tipo = ["", "Archivo M", "Adjunto", "Remesa", "eDoc/Cove Transmitido"];
      let coves = [];
      b.forEach(function (item) {
        coves.push(item.nombre);
      })

      let edocs = [];
      c.forEach(function (item) {
        edocs.push(item.nombre);
      })

      var data = {
        rfc: this.$local_storage.get("rfc"),
        coves: coves,
        edocs: edocs
      };

      axios
        .post(this.$hostname + "vucem/detalle_documentos_manifestacion/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {

            let a = b.concat(c);
            self.dataRecuperaciones = a;

            console.log(res.data);

            if (a.length > 0)
              self.dataRecuperaciones.forEach(function (r) {
                if (typeof r.estatus != 'string') {
                  r.estatus = estatus[r.estatus];
                  r.fecha = self.parseDate(r.fecha);
                  r.tipo = tipo[r.tipo];
                  if (r.nombre.substring(0, 4) == "COVE") {

                    let cove = res.data.coves.filter(a => a.cove == r.nombre)
                    if (cove.length > 0)
                      r.detalle = cove[0].factura;

                  } else {
                    let edoc = res.data.edocs.filter(a => a.eDocument == r.nombre)
                    if (edoc.length > 0)
                      r.detalle = edoc[0].nombre_original;

                  }

                }


              });
            if (row.lista_coves_recuperaciones.length > 0)
              self.lista_coves_recuperacion = row.lista_coves_recuperaciones.filter(a => a.estatus == 'No Recuperado' || a.estatus == 'Pendiente');

            if (row.lista_edocs_recuperaciones.length > 0)
              self.lista_edocs_recuperacion = row.lista_edocs_recuperaciones.filter(a => a.estatus == 'No Recuperado' || a.estatus == 'Pendiente');

            self.dialogRecuperaciones = true;
          }
        })
        .catch(err => {

          console.log(err);
        }).then(()=>{
          self.$root.$dialogLoader.hide();
        });
    },
    getAgentesPatentes: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            var agentes = res.data;

            for (var k in agentes) {
              this.agentes_patentes.push(agentes[k].patente.toString());
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    reenviarRecuperaciones: function () {
      let self = this;


      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de reenviar los archivos no recuperados nuevamente?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: 0,
            descripcion: self.manifestacion_actual,
            id_manifestacion: self.id_manifestacion_actual
          }

          if (self.lista_coves_recuperacion.length > 0){
            axios.post(this.$hostname + 'vucem/delete_solicitud_coves_agente/', datos)
              .then((res) => {
                let id_agente = self.GetidSellos(self.curp_actual);

                if (self.lista_coves_recuperacion.length > 0) {
                  self.crearprocesoCoves(id_agente);
                }

              })
              .catch((error) => {
                console.log(error);
              });
          }

          if (self.lista_edocs_recuperacion.length > 0){
              axios.post(this.$hostname + 'vucem/delete_solicitud_edocs_agente/', datos)
              .then((res) => {
                let id_agente = self.GetidSellos(self.curp_actual);

                if (self.lista_edocs_recuperacion.length > 0) {
                  self.crearprocesoEdocs(id_agente);
                }
              })
              .catch((error) => {
                console.log(error);
              }).then(() => {
                this.$root.$dialogLoader.hide();
              });
          }
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Se actualizó la información correctamente.",
              footer: ""
            });
            self.cargar();
            self.dialogRecuperaciones = false;
        }
      });

    },
    actualizarRecuperaciones: function () {
      let self = this;

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        descripcion: self.manifestacion_actual,
        id_manifestacion: self.id_manifestacion_actual,
      }
      axios.post(this.$hostname + 'vucem/update_archivos_manifestacion/', datos)
        .then((res) => {
          self.dialogRecuperaciones = false;
          self.cargar();
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "Los estatus de recuperación se actualizaron correctamente",
            footer: ""
          });

        })
        .catch((error) => {
          console.log(error);
          self.$root.$dialogLoader.hide();
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });



    },
    crearprocesoCoves(id_agente) {
      let self = this;
      let archivos = [];
      self.lista_coves_recuperacion.forEach(function (c) {
        archivos.push({ 'cove': c.nombre })
      });

      let data = {
        "rfc": self.model.rfc,
        "tipo_clave_ws": 0,
        "id_certificado": 0,
        "archivos": archivos,
        "descripcion": self.manifestacion_actual,
        "id_manifestacion": self.id_manifestacion_actual,
        "id_usuario": self.$local_storage.get("id_usuario"),
        "id_cliente": self.$local_storage.get("id_cliente")

      };

      axios.post(self.$hostname + "vucem/solicitud_coves_agente/", data)
        .then(res => {
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
        });
      if (id_agente > 0) {
        let data2 = {
          "rfc": self.model.rfc,
          "tipo_clave_ws": 1,
          "id_certificado": id_agente,
          "archivos": archivos,
          "descripcion": self.manifestacion_actual,
          "id_manifestacion": self.id_manifestacion_actual,
          "id_usuario": self.$local_storage.get("id_usuario"),
          "id_cliente": self.$local_storage.get("id_cliente")

        };

        axios.post(self.$hostname + "vucem/solicitud_coves_agente/", data2)
          .then(res => {
          })
          .catch(err => {
            console.log(err);
          }).then(() => {
          });

      }


    },
    crearprocesoEdocs(id_agente) {
      let self = this;
      let archivos = [];
      self.lista_edocs_recuperacion.forEach(function (c) {
        archivos.push({ 'edocument': c.nombre })
      });
      let data = {
        "rfc": self.model.rfc,
        "tipo_clave_ws": 0,
        "id_certificado": 0,
        "archivos": archivos,
        "descripcion": self.manifestacion_actual,
        "id_manifestacion": self.id_manifestacion_actual,
        "id_usuario": self.$local_storage.get("id_usuario"),
        "id_cliente": self.$local_storage.get("id_cliente")

      };

      axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data)
        .then(res => {
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
        });

      if (id_agente > 0) {
        let data2 = {
          "rfc": self.model.rfc,
          "tipo_clave_ws": 1,
          "id_certificado": id_agente,
          "archivos": archivos,
          "descripcion": self.manifestacion_actual,
          "id_manifestacion": self.id_manifestacion_actual,
          "id_usuario": self.$local_storage.get("id_usuario"),
          "id_cliente": self.$local_storage.get("id_cliente")

        };

        axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data2)
          .then(res => {
          })
          .catch(err => {
            console.log(err);
          }).then(() => {
          });
      }

    },
    cargarRfcsAgencia: function(){
          let data = {
              rfc_grupo: this.rfc_agencia,
          };
          axios.post(this.$hostname+ "grupos/get_clientes_grupo_by_rfc/", data)
              .then(res => {
                  if (typeof res.data !== "undefined") {
                      this.clientes_agencia = res.data;
                  }
              })
              .catch(err => {
                 this.clientes_agencia = [];
                  console.log(err);
              });
    },
    set_rfc_cliente: function(rfc=""){
        if(rfc != ""){
          this.model.rfc = rfc;
          this.model.rfc_emisor = rfc;
          this.model_nuevo.rfc_emisor = rfc;
          this.rfc = rfc;
        } else {
          this.model.rfc = this.model_nuevo.rfc;
          this.model.rfc_emisor = this.model_nuevo.rfc;
          this.model_nuevo.rfc_emisor = this.model_nuevo.rfc;
          this.rfc = this.model_nuevo.rfc;
          this.model_nuevo.lista_solicitudes = [];
          this.model_nuevo.rfc_representante = "";
        }


        //obtener cliente y ponerlo en this.cliente y cargar todo lo demas
        var cliente = this.clientes_agencia.find(x => x.rfc == this.model_nuevo.rfc)
        if(cliente){
          this.cliente = cliente.id_cliente;

          this.cargarEmisores();
          this.cargarRfcsConsulta();
          this.cargarRepresentantes();

          var permiso_patentes = this.$local_storage.get("Emanifiesto.Logistico.manifestacion", "");
          if (permiso_patentes.toString() == "100") {//Los que tengan este permiso solo pueden crear manifestaciones de sus patentes
            this.getAgentesPatentes();
            this.permisoPatentes = "100";
          }
        }

        if(rfc == ""){
            this.cargarSolicitudes(0);
            this.set_coves_modelo_nuevo();
        }
    }

  }, //methods

  mounted: function () {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.URL = this.$hostname + "manifestacion/";
    //this.URL = "http://127.0.0.1:7000/manifestacion/";
    this.cliente = this.$local_storage.get("id_cliente");
    this.model.usuario_email = this.$local_storage.get("email");
    this.model.rfc = this.$local_storage.get("rfc","");
    this.model.rfc_emisor = this.$local_storage.get("rfc","");
    this.model_nuevo.rfc = this.$local_storage.get("rfc","");
    this.model_nuevo.rfc_emisor = this.$local_storage.get("rfc","");
    this.rfc_agencia = this.$local_storage.get("rfc_agencia","");
    if(this.rfc_agencia == ""){
        //Se quita columna de RFC
        this.columns = this.columns.filter(c => c != "rfc");
    } else {
      this.cargarRfcsAgencia();
      this.model_nuevo.rfc_consulta = [this.rfc_agencia];
    }
    this.rfc = this.model.rfc;
    this.cargarEmisores();

    this.cargarRfcsConsulta();
    this.cargarRepresentantes();
    this.cargarSolicitudes(0);
    //this.cargarCertificados();

    var permiso_patentes = this.$local_storage.get("Emanifiesto.Logistico.manifestacion", "");
    if (permiso_patentes.toString() == "100") {//Los que tengan este permiso solo pueden crear manifestaciones de sus patentes
      this.getAgentesPatentes();
      this.permisoPatentes = "100";
    }



    var f = new Date();
    var f_de = new Date();
    f_de.setDate(f_de.getDate() - 15);


    let y_de = f_de.getFullYear();
    let m_de = f_de.getMonth() + 1;
    let d_de = f_de.getDate();

    if (m_de < 10)
      m_de = '0' + m_de;
    if (d_de < 10)
      d_de = '0' + d_de;

    let y = f.getFullYear();
    let m = f.getMonth() + 1;
    let d = f.getDate();


    if (m < 10)
      m = '0' + m;
    if (d < 10)
      d = '0' + d;


    this.fecha_a = y + "-" + m + "-" + d;
    this.fecha_de = y_de + "-" + m_de + "-" + d_de;
    this.cargar()
  }
};
</script>
<style scoped>
.manual>table>tr {
  page-break-inside: avoid
}

.title-table {
  font-weight: bold !important;
  background-color: lightgray !important;
}

.manual>table {
  width: 100%;
  border-collapse: collapse;
}

.manual>table,
td {
  padding-left: 2px;
  border: 1px solid #282828;
  height: 20px;
}

.titulo-principal {
  font-size: 1.1rem !important;
  font-weight: bold;
}

.manual {
  margin: 0px;
  padding: 0px;
  /*height: auto;
    width: auto;
    background-color: #fff;*/
  text-align: justify;
  font-family: Arial;
  font-size: 0.90rem;
}

.elevation-1>>>.columnaError {
  white-space: normal !important;
  min-width: 300px !important;
  text-align: justify !important;
}
</style>
